import { useState, useCallback } from "react";

/**
 * A setState hook that merges partial state updates instead of replacing state.
 * Drop-in replacement for react-use's useSetState, removed due to js-cookie vulnerability (GHSA-qjx8-664m-686j).
 */
export function useSetState<T extends object>(initialState: T = {} as T): [T, (patch: Partial<T> | ((prevState: T) => Partial<T>)) => void] {
    const [state, set] = useState<T>(initialState);
    // Accepts either a partial object or an updater function, and shallow-merges into current state.
    const setState = useCallback((patch: Partial<T> | ((prevState: T) => Partial<T>)) => {
        set(prev => ({ ...prev, ...(typeof patch === "function" ? patch(prev) : patch) }));
    }, []);
    return [state, setState];
}
